import { render } from "./EzDataTable.vue?vue&type=template&id=1339ebe5"
import script from "./EzDataTable.vue?vue&type=script&lang=js"
export * from "./EzDataTable.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__